import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import LinksContent from './LinksContent';
import LinksSkeleton from './LinksSkeleton';
import QuickLinksProvider from './QuickLinksContext';
import { dataModel } from '../util/data-model';

// Retrieving linkList from the serverSide call from Homepage Experience
// TODO : add logic for calling 'component' graphql call if linkList is not provided
const QuickLinks = ({ componentId, linkList }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('quick-links.ready'); }, []);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="sui-flex sui-bg-primary sui-py-4 md:sui-py-6" data-component="QuickLinks">
      {
        mounted ? (
          <QuickLinksProvider componentId={componentId} linkList={linkList}>
            <LinksContent />
          </QuickLinksProvider>
        ) : (
          <LinksSkeleton />
        )
      }
    </div>
  );
};

QuickLinks.displayName = 'QuickLinks';
QuickLinks.dataModel = dataModel;

QuickLinks.defaultProps = {
  componentId: '',
  linkList: undefined,
};

QuickLinks.propTypes = {
  componentId: PropTypes.string,
  linkList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    href: PropTypes.string,
    label: PropTypes.string,
  })),
};

export { QuickLinks };
